import { bianka, BIANKA_ACTIVITY_TYPES } from '@fiverr-private/obs';
import { PageView } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { PageName } from '../../types';

export interface PageViewEventProps {
    sellerId?: number;
    buyerId?: number;
    eventName: string;
    pageName: PageName;
}

export const reportPageView = ({ eventName, pageName, sellerId, buyerId }: PageViewEventProps) => {
    const { pageCtxId, userId } = getContext();

    bianka.reportActivity<PageView>({
        type: BIANKA_ACTIVITY_TYPES.PAGE_VIEW,
        event: {
            type: eventName,
            ...(pageName && {
                page: {
                    name: pageName,
                    ctxId: pageCtxId,
                },
            }),
            ...(userId && {
                user: {
                    id: userId,
                },
            }),
            ...(sellerId && {
                seller: {
                    id: sellerId,
                },
            }),
            ...(buyerId && {
                buyer: {
                    id: buyerId,
                },
            }),
        },
    });
};
